export const drpDataActionTypes = {
    load: "load",
    clear: "clear"
};
